import styled from 'styled-components/macro';

const Price = styled.div`
  flex: 0 0 auto;
  margin-left: 30px;
  color: #fff;
  font-size: 14px;

  &::after {
    content: '₽';
    margin-left: 5px;
  }
`;

export default Price;
